import { render } from "./participate.vue?vue&type=template&id=dd367bb0"
import script from "./participate.vue?vue&type=script&lang=js"
export * from "./participate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__